import { Box, Header as DefaultHeader, Text } from '@rbilabs/universal-components';

export const HeaderContainer = Box.withConfig({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginTop: '$4',
  paddingX: '$4',
});

export const Header = DefaultHeader.withConfig({
  variant: 'headerThree',
  margin: 0,
  fontSize: '3xl',
  lineHeight: 'md',
});

export const SubText = Text.withConfig({
  textAlign: 'center',
  fontWeight: 'normal',
  fontSize: 'md',
  marginY: '$2',
});
